import React from 'react'
import BaseProductForm from 'ui-shared/Forms/BaseProductForm'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const MusicCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <BaseProductForm />
      </Create>
    </SectionWrapper>
  )
}

export default MusicCreate
